import {del} from '../utils'

export default host => playlistId => del(`${host}/playlists/${playlistId}`)
